import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sales-terms',
  templateUrl: './sales-terms.component.html',
  styleUrls: ['./sales-terms.component.scss']
})
export class SalesTermsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
